export type Listener<T> = (value: T) => void;

/** Minimal typed emitter used by services (no DOM dependency). */
export class Emitter<T> {
  private listeners = new Set<Listener<T>>();

  subscribe(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  emit(value: T): void {
    for (const l of [...this.listeners]) l(value);
  }

  get size(): number {
    return this.listeners.size;
  }
}
